import React, { useEffect, useState, useRef } from "react";
import classes from "./CashReceipt.module.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import upload from "../../Assets/upload.svg"
import down from "../../Assets/download.svg"
import { Pen, Trash2, Printer } from "lucide-react";
import axios from "axios";
import RotatingLogo from '../../Assets/rotating-logo.png'
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover, Badge } from 'react-bootstrap';
import Select from "react-select";
import crop from "../../Assets/repoort.png";
import verified from "../../Assets/verified.svg";
import Swal from "sweetalert2";
import CurrencyInput from "react-currency-input-field";
import HeaderNav from "../Accoungting/HeaderNav/HeaderNav";
import { BASE_URL } from "../../Components/Styles/API/API";
import CashReciept from "../Accounting/Payments/CashReciept/CashReciept";






const CashReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState("all");
  const [currentPageFlagged, setCurrentPageFlagged] = useState(1);
  const [totalPagesFlagged, setTotalPagesFlagged] = useState(1);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [receive, setReceive] = useState('');
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [show1, setShow1] = useState(false);
  const [show2, setShow2] = useState(false);
  const handleShow1 = () => setShow1(true);
  const handleShow2 = () => setShow2(true);
   const [selectedDate2, setSelectedDate2] = useState('');
  const handleClose1 = () => setShow1(false);
  const handleClose2 = () => setShow2(false);
  const [selectedRadio, setSelectedRadio] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [description, setDescription] = useState("");
  const [amount, setAmount] = useState("");
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [bankOptions, setBankOptions] = useState([]);
  const [bankOptions2, setBankOptions2] = useState([]);
  const [paymentMode, setPaymentMode] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedBank2, setSelectedBank2] = useState(null);
  const [selectedPaymentMode, setSelectedPaymentMode] = useState(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [invoiceOptions, setInvoiceOptions] = useState([]);
  const [addpaymenntLoad, setAddPaymenntLoad] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [addpaymenntLoad2, setAddPaymenntLoad2] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalEntries, setTotalEntries] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [entriesPerPage, setEntriesPerPage] = useState(100);
  const [currentPage, setCurrentPage] = useState(1);
  const [bearer, setBearer] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableData2, setTableData2] = useState([]);
  const [user, setUser] = useState('');
  const [minDate, setMinDate] = useState("");
    const [maxDate, setMaxDate] = useState("");
    const [selectedDate, setSelectedDate] = useState('');
const [selectedPayment, setSelectedPayment] = useState('');
const [selectedBanks, setSelectedBanks] = useState('');
const [selectedDebitAccount, setSelectedDebitAccount] = useState('');
 const [paymentMethod, setPaymentMethod] = useState([]);
 const [formData, setFormData] = useState([{ sn: 1, accountName: '', accountCode: '', amount: '' }]);
 const [teller, setTeller] = useState('');
    const [incomeLoading, setIncomeLoading] = useState(false);
     const [debit1, setDebit1] = useState([]);
    const [debit2, setDebit2] = useState([]);
    const [income, setIncome] = useState([]);
    const [ledgTableData2, setLedgTableData2] = useState([]);
    const [incomeAmount, setIncomeAmount] = useState();
    const [totalCredit, setTotalCredit] = useState(0);
    const [selectOptions, setSelectOptions] = useState([]);
    const [currentMonth, setCurrentMonth] = useState('');
     const [subCat, setSubcat] = useState([]);
    const [subCat1, setSubcat1] = useState([]);
    const [banks, setBanks] = useState([]);
    const [currLoading, setCurrLoading] = useState(false);
    const [currency, setCurrency] = useState([]);
  
    const readData = async () => {
      try {
        const value = await localStorage.getItem('userToken');
        const value1 = await localStorage.getItem('tobi');
        const current = await localStorage.getItem('currentMonth');
  
  
        if (value !== null && value.trim() !== '') {
          setBearer(value);
        } else {
          navigate('/login');
          return;
        }
  
        if (value1 !== null) {
          setUser(value1);
        }
        if (current !== null) {
  const date = new Date(current);

  setCurrentMonth(date);

  // 1st and last days of that month
  const startOfDateRange = new Date(date.getFullYear(), date.getMonth(), 1);
  const endOfDateRange = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  // Format date as 'YYYY-MM-DD'
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  setMinDate(formatDate(startOfDateRange));
  setMaxDate(formatDate(endOfDateRange));

  console.log(
    'Date Range:',
    formatDate(startOfDateRange),
    'to',
    formatDate(endOfDateRange)
  );
}
  
      } catch (e) {
        alert('Failed to fetch the input from storage');
      }
    };
  
    useEffect(() => {
      readData();
    }, []);


      const headers = {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${bearer}`
  };

  
const addRow = () => {
        const newRow = {
            sn: formData.length + 1,
            accountName: '',
            accountCode: '',
            amount: ''
        };
        setFormData([...formData, newRow]);
        // setSelectedPayment('');
    };

    const deleteRow = (index) => {
        const updatedData = formData.filter((_, i) => i !== index);
        setFormData(updatedData);
    };

   

    const fetchIncome = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/incomes-receivables-payables`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const inc = response.data?.data;

          setIncome(inc);
          
         
    
        //   console.log(debitAcc, "Debit Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      useEffect(() => {
        
        fetchIncome();
    }, [bearer]);

      const uploadExcel = async () => {
      setUploadLoading(true);
        try {
          const formData = new FormData();
        formData.append('file', selectedFile[0]);
        formData.append('transaction_date', selectedDate2);
       
        // console.log(selectedFile);
    
        const headers = {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${bearer}`,
        };
    
        // const response = await axios.post(`${BASE_URL}/customer/import`,
        const response = await axios.post(`${BASE_URL}/upload-receipt-excel`,
          formData,
          { headers }
        );
    handleClose2();
    fetchExpenses();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });
    
        console.log(response.data.message);
      } catch (error) {
        const errorStatus = error.response.data.message;
    
        Swal.fire({
          icon: 'error',
          title: 'Failed',
          text: errorStatus,
        });
    
        console.error(error);
      } finally {
        setUploadLoading(false);
        }
      };

    const fetchSubCat = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const results = response.data?.data;
          const oopt = results.map((item) => ({
            label: item.gl_name,
            value: item.id,
         
            
          }));
          setSubcat(oopt);
          setSubcat1(results);
    
        //   console.log(results, "Accounts");
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

         const handleFileChange = (event) => {
      const files = event.target.files;
      const fileList = Array.from(files);
      setSelectedFile(fileList);
      
    };

    const fetchDebit1 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/bank-accounts`,{headers});
        
          const debt1 = response.data?.data;
          const oopt1 = debt1.map((item) => ({
            label: `${item.gl_code} - ${item.gl_name}`,
            value: item.id,
         
            
          }));
          setDebit1(oopt1);
     
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };
    const fetchDebit2 = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/account/cash`,{headers});
        
          const debt2 = response.data?.data;
          const oopt2 = debt2.map((item) => ({
            label: `${item.gl_code} - ${item.gl_name}`,
            value: item.id,
         
            
          }));
          setDebit2(oopt2);
     
    
      
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

    const fetchSubBanks = async () => {
        setLoading(true);
    
        try {
          const response = await axios.get(`${BASE_URL}/get-banks`,{headers});
        //     {
             
        //       headers: { 
        //         'Content-Type': 'application/json',
        //         'Authorization': `Bearer ${bearer}`
        //       }
        //     }
        //   );
          const banked = response.data?.data;
          const ban1 = banked.map((item) => ({
            label: item.bank_name,
            value: item.id,
         
            
          }));
          setBanks(ban1);
        //   console.log(response);
        } catch (error) {
          const errorStatus = error.response.data.message;
          console.error(errorStatus);
        } finally {
          setLoading(false);
        }
      };

      const createIncome = async () => {
    setIncomeLoading(true);

    try {
        const accountNames = formData.map((row) => row.accountName).filter((name) => name !== undefined);
        const amounts = formData.map((row) => row.amount).filter((amount) => amount !== undefined);
        const payload = {
            account_id: accountNames,
            gl_code: selectedDebitAccount,
            description: description,
            payment_mode: selectedPayment,
            breakdown_amount: amounts,
            total_amount: totalCredit,
            teller_no: teller,
            particulars: receive,
            currency: selectedCurrency,
            transaction_date: selectedDate,
            bank_id: selectedBanks
        };

        console.log("Payload:", payload);

        const response = await axios.post(`${BASE_URL}/post-receipt`, payload, { headers });

        console.log(response.data, "Response Data");
       handleClose1();
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: response.data.message,
        });

        // toast.success(response.data.message);
    } catch (error) {
        let errorMessage = 'An error occurred. Please try again.';
        if (error.response && error.response.data && error.response.data.message) {
          if (typeof error.response.data.message === 'string') {
              errorMessage = error.response.data.message;
          } else if (Array.isArray(error.response.data.message)) {
              errorMessage = error.response.data.message.join('; ');
          } else if (typeof error.response.data.message === 'object') {
              errorMessage = JSON.stringify(error.response.data.message);
              // toast.error(errorMessage);
            }
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Failed',
              text: JSON.stringify(error.response.data.message),
            });
        }
    } finally {
        setIncomeLoading(false);
    }
};
    


    const fetchPaymentMethod = async () => {
        setLoading(true);


        try {
            const response = await axios.get(`${BASE_URL}/income/get-payment-method`,
                {

                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${bearer}`
                    }
                }
            );
            const resultss = response.data?.data;
            setPaymentMethod(resultss);

              console.log(resultss, "PaymentModes");
        } catch (error) {
            const errorStatus = error.response.data.message;
            console.error(errorStatus);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (bearer) {
            fetchSubCat();
            fetchPaymentMethod();
            fetchDebit1();
            fetchDebit2();
        }
    }, [bearer]);

    const fetchCurrency = async () => {
        setCurrLoading(true);
        try {
          const response = await axios.get(`${BASE_URL}/fetch-all-currencies`, { headers });
          const results = response.data?.data;
            // console.log(results, "currencis")
          const options = results.map((item) => ({
            label: item.code,
            value: item.id,
            symbol: item.symbol
          }));
          setCurrency(results);
          setSelectOptions(options);
        } catch (error) {
          const errorStatus = error.response?.data?.message;
          console.log(errorStatus);
          setCurrency([]);
        } finally {
            setCurrLoading(false);
        }
      };

      useEffect(() => {
        if (bearer) {
            fetchCurrency();
            fetchSubBanks();
        }
    }, [bearer]);


    const handleCurrencyChange = (selectedOption) => {
        setSelectedCurrency(selectedOption.value);
      };

        const handleAccountChange = (selectedOption, index) => {
      const selectedAccount = selectedOption.value;
      const selectedItem = income.find(item => item.id === selectedAccount);
      // const intselectedId = parseInt(selectedAccount);
     const selectedCode = selectedItem?.gl_code
      // const selectedGlCode = subCat.find((item) => item.id === intselectedId) || '';

      const updatedFormData = [...formData];
      updatedFormData[index] = {
          ...updatedFormData[index],
          accountName: selectedAccount,
          accountCode: selectedCode,
      };

      setFormData(updatedFormData);
  };

    const handleValueChange = (value) => {
        setIncomeAmount(value);
    };

    const handleValueChange1 = (value, index) => {
        const updatedFormData = [...formData];
        updatedFormData[index] = {
            ...updatedFormData[index],
            amount: value,
        };
        setFormData(updatedFormData);
        calculateTotalCredit(); // Recalculate total credit whenever table amounts change
    };


    const calculateTotalCredit = () => {
        const total = formData.reduce((acc, item) => acc + parseFloat(item.amount || 0), 0);
        const formattedTotal = total.toFixed(2);
        setTotalCredit(formattedTotal);
    };


    useEffect(() => {

        calculateTotalCredit();
    }, [formData]);



    
    const oopt = income.map((item) => ({
      label: item.gl_name,
      value: item.id,
      
    }));


  const printRef = useRef();
  const pageMap = {
    "/dashboard": "Dashboard",
    "/transactions": "Transactions",
    "/accounts": "Accounting",
    "/reports": "Reports",
    "/banking": "Banking",
    "/settings": "Settings",
  };


    const handleRadioChange = (e) => {
    const value = e.target.value;
    setSelectedRadio(value);

    if (value === "general") {
      setSelectedCustomer(null);
    }
  };




    const handlePrevPage = () => {
    setCurrentPage(Math.max(currentPage - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage(Math.min(currentPage + 1, totalPages));
  };

    const handleDateChange = (e) => {
  const newDate = e.target.value;

  // Ensure minDate and maxDate are set
  if (!minDate || !maxDate) return;

  // Block if outside range
  if (newDate < minDate || newDate > maxDate) {
    alert(`Please select a date between ${minDate} and ${maxDate}`);
    return;
  }

  setSelectedDate(newDate);
};

 const handlePaymentChange = (event) => {
        setSelectedPayment(event.target.value);
    };
    // const handleCurrencyChange = (event) => {
    //     setSelectedCurrency(event.target.value);
    // };

    const handleAssetChange = (selectedOption) => {
        setSelectedDebitAccount(selectedOption.value);
    };
    const handleBanksChange = (selectedOption) => {
        setSelectedBanks(selectedOption.value);
    };

  // const totalEntries = filteredData.length;
  const startIndexx = (currentPage - 1) * entriesPerPage + 1;
  const endIndexx = Math.min(startIndexx + entriesPerPage - 1, totalEntries);



      const fetchExpenses = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(`${BASE_URL}/fetch_cash_receipts?page=${currentPage}`, { headers });

      const results = response.data?.data?.data;
      const resultx = response.data?.data?.total;
      setTotalEntries(resultx);
      setTableData(results);
      // console.log(results, "accounts");
      const total = response.data?.data?.last_page || 1;
      setTotalPages(total);
    } catch (error) {
      const errorStatus = error.response?.data?.message;
      console.log(errorStatus);
      setTableData([]);
    } finally {
      setIsLoading(false);
    }
  };
   const fetchReceipt2 = async () => {
        setIsLoading(true);
        try {
            const response = await axios.get(`${BASE_URL}/fetch-queried-receipts?page=${currentPage}`, { headers });
            const results = response.data?.data?.data;
            const resultx = response.data?.data?.total;
            setTotalEntries(resultx);
            console.log(results, "fetched details");
            setLedgTableData2(results);
            console.log(results, "Checkt it");
            const total = response.data?.data?.last_page || 1;
            setTotalPagesFlagged(total);
            console.log("fetched Receipts:", results);
            
        } catch (error) {
            if (error.response && error.response.status === 401) {
                navigate('/login');
            } else {
                let errorMessage = 'An error occurred. Please try again.';
                if (error.response && error.response.data && error.response.data.message) {
                    if (typeof error.response.data.message === 'string') {
                        errorMessage = error.response.data.message;
                    } else if (Array.isArray(error.response.data.message)) {
                        errorMessage = error.response.data.message.join('; ');
                    } else if (typeof error.response.data.message === 'object') {
                      
                        console.log(errorMessage);
                    }
                }
                setLedgTableData2([]);
            }
        } finally {
            setIsLoading(false);
        }
    };


  useEffect(() => {
  if (!bearer) return;

  if (selectedOption === "all") {
    fetchExpenses(currentPage);
  } else if (selectedOption === "flagged") {
    fetchReceipt2(currentPageFlagged);
  }
}, [bearer, selectedOption, currentPage, currentPageFlagged]);

const handleOptionChange = (e) => {
  setSelectedOption(e.target.value);
  // Reset pages when switching
  setCurrentPage(1);
  setCurrentPageFlagged(1);
};


    useEffect(() => {
      const fetchCurrencies = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/fetch-all-currencies`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name || item.code,
            }))
            : [];
          setCurrencyOptions(options);
        } catch (err) {
          setCurrencyOptions([]);
        }
      };
      fetchCurrencies();
    }, []);

    useEffect(() => {
      const fetchBank = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions(options);
        } catch (err) {
          setBankOptions([]);
        }
      };
      fetchBank();
    }, []);

    useEffect(() => {
      const fetchBank2 = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/get-cash-and-bank`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.gl_name,
            }))
            : [];
          setBankOptions2(options);
        } catch (err) {
          setBankOptions2([]);
        }
      };
      fetchBank2();
    }, []);

    useEffect(() => {
      const fetchPaymentMode = async () => {
        try {
          const token = localStorage.getItem("authToken");
          const res = await axios.get(`${BASE_URL}/v1/income/get-payment-method`, {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          });
          const options = Array.isArray(res.data.data)
            ? res.data.data.map((item) => ({
              value: item.id, // use only id
              label: item.name,
            }))
            : [];
          setPaymentMode(options);
        } catch (err) {
          setPaymentMode([]);
        }
      };
      fetchPaymentMode();
    }, []);


      useEffect(() => {
        const fetchCustomers = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/beneficiary`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: item.name,
              }))
              : [];
            setCustomerOptions(options);
          } catch (err) {
            setCustomerOptions([]);
          }
        };
        fetchCustomers();
      }, []);

      useEffect(() => {
        const fetchInvoiceOptions = async () => {
          try {
            const token = localStorage.getItem("authToken");
            const res = await axios.get(`${BASE_URL}/v1/fetch-pending-purchases-invoice`, {
              headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });
            console.log(res);
            // Assuming response data is an array of currencies or customers
            const options = Array.isArray(res.data.data)
              ? res.data.data.map((item) => ({
                value: item.id,
                label: `${item.invoice_number} - ${item.supplier?.name}`,
                balance: item.balance,
              }))
              : [];
            setInvoiceOptions(options);
          } catch (err) {
            setInvoiceOptions([]);
          }
        };
        fetchInvoiceOptions();
      }, []);
  

  // Skeleton loader rows
  // const SkeletonRows = () => (
  //   <>
  //     {[...Array(5)].map((_, idx) => (
  //       <tr key={idx}>
  //         {Array(10).fill().map((_, i) => (
  //           <td key={i}>
  //             <div className={classes.skeletonLoader}></div>
  //           </td>
  //         ))}
  //       </tr>
  //     ))}
  //   </>
  // );

  // Helper for status
  const statusClass = (status) => {
    if (status === "Success") return classes.greenStatus;
    if (status === "Pending") return classes.yellowStatus;
    return classes.redStatus;
  };

    // useEffect(() => {
    //   const link = document.createElement("link");
    //   link.rel = "stylesheet";
    //   link.href = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css";
    //   document.head.appendChild(link);
    //   return () => {
    //     document.head.removeChild(link);
    //   };
    // }, []);

  const addPayment = async () => {
    setAddPaymenntLoad(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-purchase-invoice`, 

        {
          payment_type: selectedRadio,
          transaction_date: paymentDate,
          supplier_id: selectedCustomer?.value,
          supplier: customerName,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

       
          handleClose1();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad(false);
    }
  };

  const addPayment2 = async () => {
    setAddPaymenntLoad2(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${BASE_URL}/v1/pay-supplier-purchase-invoice`, 

        {
          // payment_type: selectedRadio,
          transaction_date: paymentDate,
          id: selectedInvoice?.value,
          description: description,
          payment_mode: selectedPaymentMode?.value,
          currency: selectedCurrency?.value,
          amount: amount,
          credit: selectedBank?.value,
          debit: selectedBank2?.value,
        },
        { headers: {
                Authorization: `Bearer ${token}`,
                Accept: "application/json",
              },
            });

          Swal.fire({
            imageUrl: verified,
            title: 'Success!',
            text: response.data.message,
            confirmButtonText: "Okay",
            imageWidth: 48, 
            imageHeight: 48, 
            customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myButton,
            },
            allowOutsideClick: false,
            preConfirm: () => {
              Swal.close();
            }
          });

         
          handleClose2();
          setDescription("");
          setAmount("");
          setCustomerName("");
          setPaymentDate("");
          setSelectedRadio("");
          setSelectedBank(null);
          setSelectedBank2(null);
          setSelectedCurrency(null);
          setSelectedCustomer(null);
          setSelectedPaymentMode(null);
      
    } catch (error) {
      let errorMessage = "An error occurred. Please try again.";
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        if (typeof error.response.data.message === "string") {
          errorMessage = error.response.data.message;
        } else if (Array.isArray(error.response.data.message)) {
          errorMessage = error.response.data.message.join("; ");
        } else if (typeof error.response.data.message === "object") {
          errorMessage = JSON.stringify(error.response.data.message);
        }
        Swal.fire({
          imageUrl: crop,
          imageWidth: 48,
          imageHeight: 48,
          title: "Failed!",
          confirmButtonText: "Okay",
          text: JSON.stringify(error.response.data.message),
          customClass: {
            title: classes.myTitle,
            popup: classes.myText,
            confirmButton: classes.myDeclineButton,
          },
          allowOutsideClick: false, // Prevent closing by clicking outside
          preConfirm: () => {
            Swal.close(); // Explicitly close the modal
          },
        });
      }
    } finally {
      setAddPaymenntLoad2(false);
    }
  };

  const handleDateChange2 = (event) => {
      setSelectedDate2(event.target.value);
    };

//  const handlePrint = (rowData) => {
//   navigate("/invoice-previeww", {
//     state: {
//       invoiceNumber: rowData.invoice_number,
//       invoiceDate: rowData.invoice_date,
//       dueDate: rowData.due_date,
//       customer: {
//         name: rowData.customer_name,
//         phone_number: rowData.customer_phone,
//         email: rowData.customer_email,
//       },
//       items: rowData.items,
//       total: rowData.total,
//     },
//   });
// };

const handlePrint = (id) => {
        const selectedLedger = tableData.find(item => item.id === id);
        navigate('/print_cash_receipts', { state: { selectedLedger } });
    };




  return (
    <div>
      <HeaderNav  />

      <div className={classes.Container}>
        {/* <div className={classes.actions}>

                    <button className={`${classes.btnss} ${classes.greens}`}>New Sales Invoice</button>
                    <button className={classes.btns}>New Purchase Invoice</button>
                    <button className={classes.btns}>All Invoices</button>
                    <button className={classes.btns}>Product & Services </button>

                </div> */}
        <div className={classes.actionsbtn}>
          <button className={classes.btns}>New Sales Invoice</button>
          <button className={classes.btns}>New Purchase Invoice</button>
          <button className={classes.btns}>All Invoices</button>
          <button className={`${classes.btns} ${classes.greens}`}>Product & Services</button>
        </div>

        <header className={classes.Header}>
          <h2 className={classes.Title}>Receipt</h2>
          <h1 className={classes.Titles}>
            Track and manage all incoming payments from customers.
          </h1>
        </header>

          <Row>
            <Col md={3}>
              <div className={classes.thrdkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Total Receipts</p>
                  <p className={classes.kdptg1}>₦8,400,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frtkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Cleared</p>
                  <p className={classes.kdptg2}>₦4,950,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Confirmed</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.fiftkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>Pending</p>
                  <p className={classes.kdptg3}>₦3,200,000.00</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>Awaiting Clearance</p>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3}>
              <div className={classes.frstkad}>
                <div className={classes.kad}>
                  <p className={classes.kdptg}>This Month</p>
                  <p className={classes.kdptg4}>12</p>
                  <div className={classes.rvnue}>
                    <p className={classes.skaltxt}>This month</p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              {/* <img src={searchicon} alt="Search" className={classes.inputIconGreen} /> */}
              <input type="text" className={classes.searchBar} placeholder="Search receipts" />
            </div>
            <div className={classes.selectWrapper}>
              <select value={selectedOption} 
    onChange={handleOptionChange} className={classes.dropdown}>
                <option value="">Select Option</option>
                <option value="all">All Receipts</option>
                <option value="flagged">Flagged</option>
              </select>
              <span className={classes.dropdownArrow}>▼</span>
            </div>

            <div className={classes.inputWrapper}>
              <p style={{
                fontSize: 14,
                marginTop: 20
              }}>Filter here...</p>
              {/* <img src={filter} alt="Filter" className={classes.inputIcon} /> */}
            </div>
          </div>
          <div className={classes.actionsLeft}>
            <button className={classes.btnss} onClick={handleShow1}> + Add Income</button>
            <button className={classes.downBtn} onClick={handleShow2}>
              <img src={upload} alt="upload" /> Upload Income</button>
          </div>
        </div>

        <div className={classes.invoicecont}>
          <div className={classes.tableContainer}>
{selectedOption === "all" ? (
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                  <th style={{ width: "40px" }}>#</th>
                  <th  style={{ width: "80px", whiteSpace: 'wrap' }}>Transaction Date</th>
                                                                <th style={{ width: "80px" }}>Customer Name</th>
                                                                <th style={{ }}>Description</th>
                                                                <th>Mode of Payment</th>
                                                                <th>Currency</th>
                                                                <th>Amount</th>
                                                                <th>Naira Amount</th>
                                                                {/* <th>Lodged Status</th>
                                                                <th>Lodged Date</th> */}
                                                                {/* <th>Lodged Bank</th>
                                                                <th>Received By</th> */}
                                                                <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {isLoading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(9)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : tableData.length === 0 ? (
                    <tr>
                      <td colSpan={13} style={{ textAlign: "center" }}>
                        No payment found.
                      </td>
                    </tr>
                  ) : (
                    tableData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td style={{ width: 80, whiteSpace: 'nowrap' }}>{item.transaction_date}</td>
                                                        <td style={{ width: 80, whiteSpace: 'nowrap' }}>{item?.particular}</td>
                                                        <td className={classes.decribe}>{item?.description}</td>
                                                         <td style={{whiteSpace: 'nowrap'}}>{item?.mode}</td>
                                                          <td>{item?.currency?.currency  || "Naira"}</td>
                                                           
                                                        <td style={{ textAlign: "right" }}>
                                                          {parseFloat(item.total_currency_amount || item.total_amount).toLocaleString('en-US', {
                                                            minimumIntegerDigits: 1,
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                          })}
                                                        </td>
                 
                                                        <td style={{ whiteSpace: 'nowrap',textAlign:"right" }}>{item?.converted_amount}</td>
                                                                                               {/* <td style={{ textAlign: "center" }}>
  {item.bank_lodged === null ? (
    <Badge bg="light" text="danger" style={{ border: "1px solid #ff5400", fontSize: "10px" }}>
      NOT LODGED
    </Badge>
  ) : (
    <Badge bg="light" text="success" style={{ border: "1px solid #50b848", fontSize: "10px" }}>
      LODGED
    </Badge>
  )}
</td> */}

                                                        {/* <td>{item?.date_logded}</td> */}
                                                       
                                                      
                                                        {/* <td style={{ textAlign: "right" }}>
                                                          {parseFloat(item.total_converted_amount || item.total_amount).toLocaleString('en-US', {
                                                            minimumIntegerDigits: 1,
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                          })}
                                                        </td> */}
                                                       
                        <td className={classes.actions}>
                          {item?.is_queried == 1 && (
                                                          <>
                          <Pen size={16} className={classes.editIcon} />
                           </>
                                                        )}
                          <Printer  size={16} className={classes.printIcon} onClick={() => handlePrint(item.id)}
                            style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>
            ) : (
            <table className={classes.invoiceTable}>
              <thead style={{ whiteSpace: "nowrap" }}>
                <tr>
                     <th style={{ width: "40px" }}>#</th>
    <th style={{ width: "80px", whiteSpace: 'wrap' }}>Transaction Date</th>
    <th style={{ width: "80px" }}>A/C Code</th>
    <th style={{  }}>Description</th>

                                                                <th>Lodged Status</th>
                                                                <th>Lodged Date</th>
                                                                <th>Lodged Bank</th>
                                                                <th>Mode</th>
                                                                <th>Teller Number</th>
                                                                <th>Received By</th>
                                                                <th>Amount</th>
                                                                <th>Action</th>
                </tr>
              </thead>
              <tbody>

                {isLoading
                  ? Array(5)
                    .fill()
                    .map((_, idx) => (
                      <tr key={idx}>
                        {Array(12)
                          .fill()
                          .map((_, i) => (
                            <td key={i}>
                              <Skeleton height={20} style={{ marginBottom: 10 }} />
                            </td>
                          ))}
                      </tr>
                    ))
                  : ledgTableData2.length === 0 ? (
                    <tr>
                      <td colSpan={13} style={{ textAlign: "center" }}>
                        No payment found.
                      </td>
                    </tr>
                  ) : (
                    ledgTableData2.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td style={{ width: 80,  whiteSpace: 'nowrap'  }}>{item.transaction_date}</td>
                                                        <td style={{ width: 80,  whiteSpace: 'nowrap'  }}>{item?.debit_account?.gl_code}</td>
                                                        <td className={classes.decribe}>{item?.description}</td>
                                                        <td style={{ textAlign: "center" }}>
  {item.bank_lodged === null ? (
    <Badge bg="light" text="danger" style={{ border: "1px solid #ff5400", fontSize: "10px" }}>
      NOT LODGED
    </Badge>
  ) : (
    <Badge bg="light" text="success" style={{ border: "1px solid #50b848", fontSize: "10px" }}>
      LODGED
    </Badge>
  )}
</td>

                                                        <td>{item?.date_logded}</td>
                                                        <td style={{ whiteSpace: 'nowrap' }}>{item?.bank_lodged?.gl_name}</td>
                                                        <td style={{whiteSpace: 'nowrap'}}>{item?.mode?.name}</td>
                                                       <td>{item?.teller_number}</td>
                                                        <td style={{whiteSpace: 'nowrap'}}>{item?.user?.name}</td>
                                                        <td style={{ textAlign: "right" }}>
                                                          {parseFloat(item.amount).toLocaleString('en-US', {
                                                            minimumIntegerDigits: 1,
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                          })}
                                                        </td>
                        <td className={classes.actions}>
                          {item?.is_queried == 1 && (
                                                          <>
                          <Pen size={16} className={classes.editIcon} />
                           </>
                                                        )}
                          <Printer  size={16} className={classes.printIcon} onClick={() => handlePrint(item.id)}
                            style={{ cursor: "pointer" }} />
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>
)}

          </div>

          <div className={classes.paginationContainer}>

            <div className={classes.paginationControls}>
                          {selectedOption === "all" ? (
                            <div>
              <button>Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPage - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPage ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPage ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPage(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
             ) : (

                            <div>
              <button>Previous</button>
              {[...Array(totalPages)].map((_, page) => {
                  // Show only 5 pages or less if available
                  if (page < 5 || page === currentPageFlagged - 1 || page === totalPages - 1) {
                    return(
                <button className={classes.active}  key={page + 1}
                style={{
                  color: page + 1 === currentPageFlagged ? '#ffffff' : '#000',
                  backgroundColor: page + 1 === currentPageFlagged ? '#174384' : 'gainsboro',
                  cursor: "pointer"
                }}
                onClick={() => setCurrentPageFlagged(page + 1)}
              > {page + 1}
              </button>
                    );
                  }
                  return null;
                })}
              <button
                onClick={handleNextPage}
                disabled={currentPageFlagged === totalPages}
              >Next
              </button>
              <span className={classes.pageText}>Displaying {startIndexx} - {endIndexx} of {totalEntries}</span>
            </div>
             )}
            </div>
          </div>


        </div>
      </div>
       <CashReciept
                      isOpen={show1}
                      onClose={() => setShow1(false)}
                      fetchExpenses={fetchExpenses}
                  />
     


      <Modal show={show2} onHide={handleClose2} animation={false}>
        <Modal.Header closeButton>
          <Modal.Title style={{fontSize: 14}}>Upload Income</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <a href="https://account-api.patna.ng/api/v1/download-receipt-excel" download>
          <button className={classes.downBtn} >
              <img src={down} alt="down" /> Download Template</button></a>
              <div style={{marginBottom: 15}} />
 <Modal.Footer />
           <Form >
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Transaction Date</Form.Label>
                            <Form.Control
                              type="date"
                              onChange={handleDateChange2} 
                              value={selectedDate2}
          //                     min={minDate}
          // max={maxDate}
                            />
                          </Form.Group>                          
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Upload Excel File</Form.Label>
                            <Form.Control
                              type="file"
                              accept=".xlsx, .xls, .csv"
                              onChange={handleFileChange}
                            />
                          </Form.Group>
                        </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose2}>
            Go back
          </Button>
          <Button variant="primary" onClick={uploadExcel} className={classes.btnss}>
            Upload Income
          </Button>
        </Modal.Footer>
      </Modal>
{incomeLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
{uploadLoading && (
        <div className={classes.overlay}>
          <img src={RotatingLogo} alt="Loading..." className={classes.spinnerLogo} />
        </div>
      )}
      {/* <Footer /> */}
    </div>
  );
};

export default CashReceipt;
